import React from 'react';

export default function Avatar({ name, size, bg, color }) {
  const sz = size || 36;
  const initials = name
    ? name.split(' ').slice(0, 2).map(p => p[0]).join('').toUpperCase()
    : '?';
  return (
    <div style={{
      width: sz, height: sz, borderRadius: '50%',
      background: bg || '#CC1A00',
      color: color || 'white',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontWeight: 700, fontSize: Math.round(sz * 0.37), flexShrink: 0,
      userSelect: 'none',
    }}>
      {initials}
    </div>
  );
}
